import { Step } from 'components/app/Onboarding/FlowWrapper';

import { Form } from './Form';

export const ConfirmationStep: Step = ({ children }): JSX.Element =>
  children({
    childProps: {},
    Form,
  });
